"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cond = exports.orThrow = exports.orFragment = exports.expect = exports.iff = void 0;
var react_1 = __importDefault(require("react"));
/**
 * Conditionally return a given value.
 * ?> This is a useful replacement for `when ? something : undefined`.
 *
 * @example
 * ```ts
 * function getSx(isRed: boolean) {
 *  return { fontFamily: 'monospace', backgroundColor: iff(isRed, 'red') }
 * }
 *
 * console.log(getSx(false)); // { fontFamily: 'monospace' }
 * console.log(getSx(true)); // { fontFamily: 'monospace', backgroundColor: 'red' }
 * ```
 *
 * @param cond The condition to check
 * @param v The value to return if the `cond` is true
 * @returns v if `cond` is true, otherwise `undefined`
 *
 * @category Condition
 */
function iff(cond, v) {
    if (!!cond)
        return v;
    else
        return undefined;
}
exports.iff = iff;
/**
 * Expect a certain condition and, given that condition, return a value.
 *
 * ?> This often serves as a fill-in for `const v = maybe ? thing : (throw 'err')`, since that syntax is not supported.
 *
 * @example
 * ```ts
 * type Result = {
 *  isFetched: boolean,
 *  isSuccess: boolean,
 *  data?: string,
 *  ...
 * }
 *
 * function getData() {
 *   const res: Result = ...
 *
 *   if (res.isFetched)
 *     return expect(res.isSuccess, res.data, 'result failed!');
 * }
 * ```
 *
 * @param assertation The control assertation to check.
 * @param then The value to return if the assertation passes.
 * @param err The Error or error message to throw of the assertation fails. If none is provided, a generic message will be thrown instead.
 * @returns The `then` value, given a passing assertation.
 *
 * @category Condition
 */
function expect(assertation, then, err) {
    if (assertation)
        return then;
    else
        throw err !== null && err !== void 0 ? err : "'expect' method found false assertation!";
}
exports.expect = expect;
function orFragment(cond, node) {
    return cond ? node : react_1.default.createElement(react_1.default.Fragment);
}
exports.orFragment = orFragment;
/**
 * Return the given value if it is not nullish, otherwise throw the given error. If no error is provided, a generic error will be thrown instead.
 *
 * ?> Helpful to support the lack of `(someObject ?: throw "err").someMethod()` syntax.
 *
 * @example
 * ```ts
 * const fruits = ["apple", "pear", "banana"];
 * console.log(orThrow(fruits.find(v => v == "orange"), "could not find 'orange'").toUpperCase()); // throws "could not find 'orange'"
 * console.log(orThrow(fruits.find(v => v == "pear"), "could not find 'pear'").toUpperCase()); // "PEAR"
 * ```
 *
 * @category Condition
 */
function orThrow(v, err) {
    if (typeof v == "undefined" || v === null)
        throw err !== null && err !== void 0 ? err : "orThrow found a nullish value!";
    else
        return v;
}
exports.orThrow = orThrow;
/**
 * Allows for simple control branching. Each instruction supplied is a tuple who's first value,
 * is a boolean, and who's second value is the value to return if the aformentioned boolean is `true`.
 *
 * @example
 * ```ts
 * type Result = { type: "ok" | "warn" | "err"; msg: string };
 *
 * function alert(res: Result) {
 *   console.log(
 *       cond(
 *           [res.type == "ok", () => `Good news: ${res.msg}`],
 *           [res.type == "warn", () => `Quick Heads Up: ${res.msg}`],
 *           [res.type == "err", () => `Oh No!: ${res.msg}`],
 *       ),
 *   );
 * }
 *
 * alert({ msg: 'everything is good', type: 'ok' }) // Good news: everything is good'
 * alert({ msg: 'some stuff is down', type: 'warn' }) // Quick Heads Up: some stuff is down
 * alert({ msg: 'the world is on fire', type: 'err' }) // Oh No!: the world is on fire
 * ```
 *
 * @category Condition
 */
function cond() {
    var e_1, _a;
    var instrs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        instrs[_i] = arguments[_i];
    }
    try {
        for (var instrs_1 = __values(instrs), instrs_1_1 = instrs_1.next(); !instrs_1_1.done; instrs_1_1 = instrs_1.next()) {
            var _b = __read(instrs_1_1.value, 2), when = _b[0], then = _b[1];
            if (when)
                return then();
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (instrs_1_1 && !instrs_1_1.done && (_a = instrs_1.return)) _a.call(instrs_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    throw "Failed to match any condition in `cond`";
}
exports.cond = cond;
